import { LinearGradient } from 'expo-linear-gradient';
import * as React from 'react';
import {
    BodyMediumEmphasized,
    FootnoteRegular,
    Private,
    useThemeColors,
    XStack,
    YStack,
} from 'smoothie';

import { getCurrentMonthName } from '../../../common/utils/dateUtils';

interface InterestCashBackEarnedProps {
    interestEarned: string;
    cashBackEarned?: string;
    showCashBack: boolean;
}

const InterestCashBackEarned = ({
    interestEarned,
    cashBackEarned,
    showCashBack,
}: InterestCashBackEarnedProps) => {
    const month = getCurrentMonthName();
    const { getColor } = useThemeColors();
    const white = getColor('$white');
    const gray200 = getColor('$gray200');

    return (
        <>
            <LinearGradient
                colors={[white, gray200, white]}
                locations={[0, 0.5, 1]}
                start={{ x: 0, y: 1 }}
                end={{ x: 1, y: 1 }}
                style={{
                    height: 1,
                    width: '100%',
                }}
                pointerEvents="none"
            />
            <XStack width="100%" justifyContent="space-between">
                <YStack flex={1} alignItems="center" paddingVertical={14}>
                    <Private>
                        <BodyMediumEmphasized color="$green1000">
                            +{interestEarned}
                        </BodyMediumEmphasized>
                    </Private>
                    <FootnoteRegular color="$gray1000">
                        {month} interest accrued
                    </FootnoteRegular>
                </YStack>
                {showCashBack && (
                    <LinearGradient
                        colors={[gray200, white]}
                        locations={[0, 0.5]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={{
                            flexGrow: 0,
                            flexBasis: 1,
                            height: '100%',
                            width: 1,
                        }}
                        pointerEvents="none"
                    />
                )}
                {showCashBack && (
                    <YStack flex={1} alignItems="center" paddingVertical={14}>
                        <Private>
                            <BodyMediumEmphasized color="$green1000">
                                +{cashBackEarned ?? '$0.00'}
                            </BodyMediumEmphasized>
                        </Private>
                        <FootnoteRegular color="$gray1000">
                            {month} cash back
                        </FootnoteRegular>
                    </YStack>
                )}
            </XStack>
        </>
    );
};

export default InterestCashBackEarned;
